<template>
  <div class="weixin-login-account">
    <div class="form">
      <TextField v-model="name" placeholder="用户" />
      <TextField v-model="password" placeholder="密码" type="password" />
      <IconTextButton
        :icon="selectedConnectOption.icon"
        :text="submitButtonText"
        :isActive="isVerified"
        variations="fluid"
        @click="onClickSubmitButton"
      />
    </div>
    <div class="action">
      <button class="button basic fluid" @click="onClickSwitchOptionButton">
        {{ switchOptionButtonText }}
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import IconTextButton from '@/app/components/icon-text-button';
import TextField from '@/app/components/text-field';

export default defineComponent({
  name: 'WeixinLoginAccount',

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {
      name: '',
      password: '',
    };
  },

  /**
   * 监视
   */
  watch: {
    name() {
      if (!this.status) {
        this.setStatus('');
      }
    },
    password() {
      if (!this.status) {
        this.setStatus('');
      }
    },
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      selectedConnectOption: 'weixin/login/selectedConnectOption',
      connectOptions: 'weixin/login/connectOptions',
      _name: 'invite/register/name',
      _password: 'invite/register/password',
    }),

    isVerified() {
      return this.name && this.password ? true : false;
    },

    submitButtonText() {
      return `确定${this.selectedConnectOption.title}`;
    },

    nextOption() {
      return this.connectOptions.find(
        option => option.value !== this.selectedConnectOption.value,
      );
    },

    switchOptionButtonText() {
      return `${this.nextOption.title} ↓`;
    },
  },

  /**
   * 已创建
   */
  created() {
    if (this._name) {
      this.name = this._name;
    }

    if (this._password) {
      this.password = this._password;
    }
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapMutations({
      setCurrentLoginStepName: 'weixin/login/setCurrentLoginStepName',
      setStatus: 'weixin/login/setStatus',
    }),

    ...mapActions({
      pushMessage: 'notification/pushMessage',
      weixinLoginConnect: 'weixin/login/weixinLoginConnect',
      weixinLoginCreateConnect: 'weixin/login/weixinLoginCreateConnect',
    }),

    async onClickSubmitButton() {
      if (this.selectedConnectOption.value === 'createAccount') {
        return this.setStatus('暂时未开放注册，请关联已有帐户。');

        // await this.weixinLoginCreateConnect({
        //   data: {
        //     name: this.name,
        //     password: this.password,
        //   },
        // });
      }

      if (!this.name) {
        return this.setStatus('请输入用户名。');
      }

      if (!this.password) {
        return this.setStatus('请输入用户密码。');
      }

      try {
        if (this.selectedConnectOption.value === 'verifyAccount') {
          await this.weixinLoginConnect({
            data: {
              name: this.name,
              password: this.password,
            },
          });
        }

        this.setCurrentLoginStepName('connectAccountCompleted');
      } catch (error) {
        if (error.data && error.data.statusCode === 401) {
          this.setStatus('没有权限。');
        }

        if (error.data && error.data.statusCode === 400) {
          this.setStatus(error.data.message);
        }

        // this.pushMessage({ content: error.data.message });
      }
    },

    onClickSwitchOptionButton() {
      this.setCurrentLoginStepName(this.nextOption.value);
    },
  },

  /**
   * 使用组件
   */
  components: {
    TextField,
    IconTextButton,
  },
});
</script>

<style scoped>
@import './styles/weixin-login-account.css';
</style>
